import { merge } from '../../../helper';

import appendChildren from '../../../general/append/appendChildren';

import * as exOption from '../../option';

// ----------------------------------------------------------------------------

function resetOptions(element: HTMLSelectElement, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        disabled: true,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Clear
    element.innerHTML = '';

    // ------------------------------------------------------------------------

    // Create element (options)
    const listOption = exOption.create(defConfig);

    // Append children
    appendChildren(element, listOption);

    // ------------------------------------------------------------------------

    // If using disabled
    if (defConfig.disabled === true) {
        element.disabled = !element.options.length;
    }
}

// ----------------------------------------------------------------------------

export default resetOptions;
